export const careerTabs = [
  "All Jobs",
  "Design",
  "Development",
  "Marketing",
  "Finance",
];

export const job = [
  // //all Jobs
  // {
  //   jobs: [
  //     {
  //       id: 1,
  //       label: "Assistant Manager",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Duisburg, Germany",
  //       type: "Full Time Job",
  //     },
  //     {
  //       id: 2,
  //       label: "Measurement Engineer",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Duisburg, Germany",
  //       type: "Remote, Part Time",
  //     },
  //     {
  //       id: 3,
  //       label: "Web Developer",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Islamabad, Pakistan",
  //       type: "Full Time Job",
  //     },
  //     {
  //       id: 4,
  //       label: "Graphic Designer",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Dubia, UAE",
  //       type: "Full Time Job",
  //     },
  //   ],
  // },
  // //Design
  // {
  //   jobs: [
  //     {
  //       id: 5,
  //       label: "Design 1",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Islamabad, Pakistan",
  //       type: "Full Time Job",
  //     },
  //     {
  //       id: 6,
  //       label: "Design 2",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Islamabad, Pakistan",
  //       type: "Full Time Job",
  //     },
  //     {
  //       id: 7,
  //       label: "Design 3",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Islamabad, Pakistan",
  //       type: "Full Time Job",
  //     },
  //     {
  //       id: 8,
  //       label: "Design 4",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Islamabad, Pakistan",
  //       type: "Full Time Job",
  //     },
  //   ],
  // },
  // //Development
  // {
  //   jobs: [
  //     {
  //       id: 9,
  //       label: "Development 1",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Islamabad, Pakistan",
  //       type: "Full Time Job",
  //     },
  //     {
  //       id: 10,
  //       label: "Development 2",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Islamabad, Pakistan",
  //       type: "Full Time Job",
  //     },
  //     {
  //       id: 11,
  //       label: "Development 3",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Islamabad, Pakistan",
  //       type: "Full Time Job",
  //     },
  //     {
  //       id: 12,
  //       label: "Development 4",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Islamabad, Pakistan",
  //       type: "Full Time Job",
  //     },
  //   ],
  // },
  // //Marketing
  // {
  //   jobs: [
  //     {
  //       id: 13,
  //       label: "Marketing 1",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Islamabad, Pakistan",
  //       type: "Full Time Job",
  //     },
  //     {
  //       id: 14,
  //       label: "Marketing 2",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Islamabad, Pakistan",
  //       type: "Full Time Job",
  //     },
  //     {
  //       id: 15,
  //       label: "Marketing 3",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Islamabad, Pakistan",
  //       type: "Full Time Job",
  //     },
  //     {
  //       id: 16,
  //       label: "Marketing 4",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Islamabad, Pakistan",
  //       type: "Full Time Job",
  //     },
  //   ],
  // },
  // //Finance
  // {
  //   jobs: [
  //     {
  //       id: 17,
  //       label: "Finance 1",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Islamabad, Pakistan",
  //       type: "Full Time Job",
  //     },
  //     {
  //       id: 18,
  //       label: "Finance 2",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Islamabad, Pakistan",
  //       type: "Full Time Job",
  //     },
  //     {
  //       id: 19,
  //       label: "Finance 3",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Islamabad, Pakistan",
  //       type: "Full Time Job",
  //     },
  //     {
  //       id: 20,
  //       label: "Finance 4",
  //       discription:
  //         "Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit. Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris excepteur.Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.",
  //       location: "Islamabad, Pakistan",
  //       type: "Full Time Job",
  //     },
  //   ],
  // },
];

export const jobDetails = [
  {
    jobId: 1,
    discription:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    requirements: ["Requirement 1", "Requirement 2", "Requirement 3"],
  },
  {
    jobId: 2,
    discription:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    requirements: ["Requirement 1", "Requirement 2", "Requirement 3"],
  },
  {
    jobId: 3,
    discription:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    requirements: ["Requirement 1", "Requirement 2", "Requirement 3"],
  },
  {
    jobId: 4,
    discription:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    requirements: ["Requirement 1", "Requirement 2", "Requirement 3"],
  },
  {
    jobId: 5,
    discription:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    requirements: ["Requirement 1", "Requirement 2", "Requirement 3"],
  },
  {
    jobId: 6,
    discription:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    requirements: ["Requirement 1", "Requirement 2", "Requirement 3"],
  },
  {
    jobId: 7,
    discription:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    requirements: ["Requirement 1", "Requirement 2", "Requirement 3"],
  },
  {
    jobId: 8,
    discription:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    requirements: ["Requirement 1", "Requirement 2", "Requirement 3"],
  },
];
